import React from 'react';

import { WpPageLayout, WpPageHeader, WpPageTitle, WpPageBody } from '../../components/page-layout';

const HomePage = () => {
  return (
    <WpPageLayout>
      <WpPageHeader sticky>
        <WpPageTitle title="Design System" />
      </WpPageHeader>
      <WpPageBody>
        <>Design System Docs - more coming soon!</>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default HomePage;
